import { Image } from 'antd';
import React, { FC, useState } from 'react';
import styled from 'styled-components';

const InvisibleImage = styled(Image).attrs({ width: 0, height: 0 })`
  visibility: hidden;
  width: 0 !important;
  height: 0 !important;
`;

interface ContainerProps {
  width?: string;
}

const Container = styled.div<ContainerProps>`
  .ant-image {
    display: none;
  }
  width: ${(p) => p.width ?? 'auto'};
`;

/*
 * ImageHandler
 * @description is simple parent wrapper for RTE to handle image preview.
 * Expectation: When user clicks on image in editor during readonly, we need to open image preview.
 * Solution: Attaching a click event listener and when target is an img then open a preview.
 * Caveat: This solution won't work if RTE stop propagating click event to parent.
 * */
export const ImageHandler: FC<{
  width?: string;
  canOpenImage?: boolean;
}> = ({ canOpenImage, children, width }) => {
  const [currentImageSrc, setCurrentImageSrc] = useState<string | undefined>();

  const handleClick = (e) => {
    if (e.target && e.target.tagName === 'IMG') {
      const {
        target: { src },
      } = e;

      if (src) {
        setCurrentImageSrc(src);
      }
    }
  };

  const onVisibleChange = (isVisible: boolean) => {
    if (!isVisible) {
      setCurrentImageSrc('');
    }
  };

  return (
    <Container
      onClick={canOpenImage ? (e) => handleClick(e) : undefined}
      width={width}
    >
      {currentImageSrc ? (
        <InvisibleImage
          preview={{
            src: currentImageSrc,
            visible: Boolean(currentImageSrc),
            onVisibleChange,
          }}
        />
      ) : null}
      {children}
    </Container>
  );
};
